<mat-expansion-panel id="{{ assignment[0].AssignmentID }}" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title fxLayoutAlign="space-between" class="panel-title">
      <div fxLayout="row" fxLayoutAlign="flex-start center">
        <div class="assignment-id">
          {{ assignment[0].AssignmentID }}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="flex-start center">
        <div>
          Start Date: <span class="start-date">{{ assignment[0].StartDate }}</span>
        </div>
        <div>
          Due Date: <span class="due-date">{{ assignment[0].DueDate }}</span>
        </div>
        <div class="student-count">
          {{ assignment.length }}
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div>
     <!-- Table legend describing cell color  -->
     <div fxFlex fxLayout="row" fxLayoutAlign="space-around" class="color-indicator-container" fxLayoutGap="15px grid">
      <div *ngFor="let colorIndicator of colorIndicators" class="color-indicator">
        <span class="status-color" [ngStyle]="{'background-color': colorIndicator.color}">
        </span>
        <span class="status-label">
          {{ colorIndicator.label }}
        </span>
      </div>
    </div>
  </div>
  

  <div 
    class="panel-body" 
    fxLayout="row wrap" 
    fxLayoutAlign="space-around center" 
    fxLayoutGap="35px grid">
    <div *ngFor="let student of assignment">
      <student-card 
      [student]="student" 
      [classID]="classID"
      [lessonName]="lessonName"></student-card>
    </div>
  </div>
</mat-expansion-panel>
